import superagent from 'superagent';
// import webservice from './webservice';
import getCookie from './getCookie';

export default async function getEstadoCuenta_PedidosPendientes({ kit }) {
  const url = `${process.env.REACT_APP_ADMI_WEBSERVICE}/getEstadoCuenta_PedidosPendientes?usuarioOK=${kit}&dominio=${window.location.hostname}`;

  let responsePedidos = {};

  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      responsePedidos = res.body;
    })
    .catch((err) => {
      console.log(err);
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      responsePedidos = resp;
    });

  return responsePedidos;
}
